import create, { StateCreator, State } from 'zustand'

export function createStore<TState extends State>(createState: StateCreator<TState>) {
  return create(createState)
}
